<div id="shape-container-{{shape.id}}-{{location}}">
    <canvas #canvas width="60" height="60" id="shape-{{shape.id}}-{{location}}"></canvas>
</div>
